/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminDelegateDocumentRequest } from '../models/AdminDelegateDocumentRequest';
import type { AIClassification } from '../models/AIClassification';
import type { ClassificationApproval } from '../models/ClassificationApproval';
import type { ClassifyDocument } from '../models/ClassifyDocument';
import type { CompanyDocuments } from '../models/CompanyDocuments';
import type { CreateOrDeleteDocumentReferenceObject } from '../models/CreateOrDeleteDocumentReferenceObject';
import type { DelegateDocumentRequest } from '../models/DelegateDocumentRequest';
import type { DocumentReferenceClassification } from '../models/DocumentReferenceClassification';
import type { DocumentReferenceObjectView } from '../models/DocumentReferenceObjectView';
import type { DocumentRequestView } from '../models/DocumentRequestView';
import type { FileUpdateRequestedFiles } from '../models/FileUpdateRequestedFiles';
import type { FolderModel } from '../models/FolderModel';
import type { FolderView } from '../models/FolderView';
import type { IndividualRequestedFile } from '../models/IndividualRequestedFile';
import type { RedelegateDocumentRequest } from '../models/RedelegateDocumentRequest';
import type { TaskModel } from '../models/TaskModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DocumentsService {
  /**
   * Manually trigger document classification for a file
   * @param data
   * @returns AIClassification
   * @throws ApiError
   */
  public static apiDocumentsClassificationClassifyCreate(
    data: ClassifyDocument,
  ): CancelablePromise<AIClassification> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/classification/classify/',
      body: data,
      errors: {
        400: `Classification failed`,
        404: `File not found`,
      },
    });
  }
  /**
   * List all AI classifications for a specific file.
   * GET /api/documents/classification/file/<file_id>/
   * @param fileId
   * @returns AIClassification
   * @throws ApiError
   */
  public static apiDocumentsClassificationFileRead(
    fileId: string,
  ): CancelablePromise<Array<AIClassification>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/classification/file/{file_id}/',
      path: {
        'file_id': fileId,
      },
    });
  }
  /**
   * List all document references pending auto-classification approval.
   * GET /api/documents/classification/pending/
   * GET /api/documents/classification/pending/?md_id=<measurement_date_id>
   * @returns DocumentReferenceClassification
   * @throws ApiError
   */
  public static apiDocumentsClassificationPendingList(): CancelablePromise<Array<DocumentReferenceClassification>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/classification/pending/',
    });
  }
  /**
   * Approve a document's auto-classification suggestion
   * @param documentReferenceId
   * @param data
   * @returns DocumentReferenceClassification
   * @throws ApiError
   */
  public static apiDocumentsClassificationApproveCreate(
    documentReferenceId: string,
    data: ClassificationApproval,
  ): CancelablePromise<DocumentReferenceClassification> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/classification/{document_reference_id}/approve/',
      path: {
        'document_reference_id': documentReferenceId,
      },
      body: data,
      errors: {
        400: `Document not pending classification approval`,
        404: `Document reference not found`,
      },
    });
  }
  /**
   * Decline a document's auto-classification suggestion
   * @param documentReferenceId
   * @param data
   * @returns DocumentReferenceClassification
   * @throws ApiError
   */
  public static apiDocumentsClassificationDeclineCreate(
    documentReferenceId: string,
    data: ClassificationApproval,
  ): CancelablePromise<DocumentReferenceClassification> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/classification/{document_reference_id}/decline/',
      path: {
        'document_reference_id': documentReferenceId,
      },
      body: data,
      errors: {
        400: `Document not pending classification approval`,
        404: `Document reference not found`,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this measurement date documents.
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsCompanyRead(
    id: number,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<CompanyDocuments>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/company/{id}',
      path: {
        'id': id,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * @param mdId
   * @param data
   * @returns DocumentReferenceObjectView
   * @throws ApiError
   */
  public static apiDocumentsDocumentReferenceObjectsCreate(
    mdId: string,
    data: CreateOrDeleteDocumentReferenceObject,
  ): CancelablePromise<Array<DocumentReferenceObjectView>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/document-reference-objects/{md_id}',
      path: {
        'md_id': mdId,
      },
      body: data,
    });
  }
  /**
   * Download actual file content from S3 instead of returning a signed URL.
   * Supports both direct file download and base64-encoded response.
   * @param fileId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsDownloadContentRead(
    fileId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/download-content/{file_id}',
      path: {
        'file_id': fileId,
      },
    });
  }
  /**
   * @param fileId
   * @param versionId Optional version ID of the file to download a specific version (not used since we are not retaining versions ids yet)
   * @param firmId Optional firm ID to specify the firm context for the file download. Used when downloading a firm summary report.
   * @returns any Presigned URL to download the file.
   * @throws ApiError
   */
  public static apiDocumentsDownloadRead(
    fileId: string,
    versionId?: string,
    firmId?: string,
  ): CancelablePromise<{
    signed_url?: string;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/download/{file_id}',
      path: {
        'file_id': fileId,
      },
      query: {
        'version_id': versionId,
        'firm_id': firmId,
      },
    });
  }
  /**
   * @param mdId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFeatureObjectsRead(
    mdId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/feature-objects/{md_id}',
      path: {
        'md_id': mdId,
      },
    });
  }
  /**
   * @param mdPk
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFileUploadRequestRead(
    mdPk: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/file-upload-request/{md_pk}',
      path: {
        'md_pk': mdPk,
      },
    });
  }
  /**
   * @param mdPk
   * @param fileUuid
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFileUploadRequestRead1(
    mdPk: string,
    fileUuid: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/file-upload-request/{md_pk}/{file_uuid}',
      path: {
        'md_pk': mdPk,
        'file_uuid': fileUuid,
      },
    });
  }
  /**
   * @param mdPk
   * @param companyId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsHasDocumentsRead(
    mdPk: string,
    companyId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/has-documents/{md_pk}/{company_id}',
      path: {
        'md_pk': mdPk,
        'company_id': companyId,
      },
    });
  }
  /**
   * @param mdId
   * @param filePk
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsReferenceCreate(
    mdId: string,
    filePk: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/reference/{md_id}/{file_pk}',
      path: {
        'md_id': mdId,
        'file_pk': filePk,
      },
    });
  }
  /**
   * @param mdId
   * @param filePk
   * @returns void
   * @throws ApiError
   */
  public static apiDocumentsReferenceDelete(
    mdId: string,
    filePk: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/documents/reference/{md_id}/{file_pk}',
      path: {
        'md_id': mdId,
        'file_pk': filePk,
      },
    });
  }
  /**
   * @param mdId
   * @param filePk
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsReferenceObjectCreate(
    mdId: string,
    filePk: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/reference_object/{md_id}/{file_pk}',
      path: {
        'md_id': mdId,
        'file_pk': filePk,
      },
    });
  }
  /**
   * @param mdId
   * @param filePk
   * @returns void
   * @throws ApiError
   */
  public static apiDocumentsReferenceObjectDelete(
    mdId: string,
    filePk: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/documents/reference_object/{md_id}/{file_pk}',
      path: {
        'md_id': mdId,
        'file_pk': filePk,
      },
    });
  }
  /**
   * @param documentReferenceId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsReferencesRead(
    documentReferenceId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/references/{document_reference_id}',
      path: {
        'document_reference_id': documentReferenceId,
      },
    });
  }
  /**
   * @param data
   * @returns DocumentRequestView
   * @throws ApiError
   */
  public static apiDocumentsRequestCreate(
    data: DocumentRequestView,
  ): CancelablePromise<DocumentRequestView> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/request',
      body: data,
    });
  }
  /**
   * @param data
   * @returns IndividualRequestedFile
   * @throws ApiError
   */
  public static apiDocumentsRequestedFileCreate(
    data: IndividualRequestedFile,
  ): CancelablePromise<IndividualRequestedFile> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/requested-file',
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this requested file.
   * @param data
   * @returns IndividualRequestedFile
   * @throws ApiError
   */
  public static apiDocumentsRequestedFileUpdate(
    id: number,
    data: IndividualRequestedFile,
  ): CancelablePromise<IndividualRequestedFile> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/documents/requested-file/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this requested file.
   * @param data
   * @returns IndividualRequestedFile
   * @throws ApiError
   */
  public static apiDocumentsRequestedFilePartialUpdate(
    id: number,
    data: IndividualRequestedFile,
  ): CancelablePromise<IndividualRequestedFile> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/requested-file/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this requested file.
   * @returns void
   * @throws ApiError
   */
  public static apiDocumentsRequestedFileDelete(
    id: number,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/documents/requested-file/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * After each successful upload (to bucket) we hit this endpoint to create File and DocumentReference objects,
   * to update the RequestedFile status, and check if the entire task is done.
   * @param documentRequestId
   * @param hmacToken
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsRequestsFileUploadStatusCreate(
    documentRequestId: string,
    hmacToken: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/requests/file-upload-status/{document_request_id}/{hmac_token}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
      },
    });
  }
  /**
   * Return current delegation status for the document request.
   * @param taskId
   * @param page A page number within the paginated result set.
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsRequestsTaskAppDelegateList(
    taskId: string,
    page?: number,
  ): CancelablePromise<{
    count: number;
    next?: string | null;
    previous?: string | null;
    results: Array<AdminDelegateDocumentRequest>;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/requests/task/{task_id}/app-delegate',
      path: {
        'task_id': taskId,
      },
      query: {
        'page': page,
      },
    });
  }
  /**
   * Admin-level delegation endpoint.
   * @param taskId
   * @param data
   * @returns AdminDelegateDocumentRequest
   * @throws ApiError
   */
  public static apiDocumentsRequestsTaskAppDelegateCreate(
    taskId: string,
    data: AdminDelegateDocumentRequest,
  ): CancelablePromise<AdminDelegateDocumentRequest> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/requests/task/{task_id}/app-delegate',
      path: {
        'task_id': taskId,
      },
      body: data,
    });
  }
  /**
   * @param documentRequestId
   * @param hmacToken
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsRequestsValidateTokenRead(
    documentRequestId: string,
    hmacToken: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/requests/validate-token/{document_request_id}/{hmac_token}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
      },
    });
  }
  /**
   * Allows a portal user to delegate their document request to another person.
   * No login required - uses HMAC token authentication.
   * @param documentRequestId
   * @param hmacToken
   * @param data
   * @returns DelegateDocumentRequest
   * @throws ApiError
   */
  public static apiDocumentsRequestsDelegateCreate(
    documentRequestId: string,
    hmacToken: string,
    data: DelegateDocumentRequest,
  ): CancelablePromise<DelegateDocumentRequest> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/delegate',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
      },
      body: data,
    });
  }
  /**
   * Allows a portal user to re-delegate (reassign) an existing delegation to a different person.
   * This soft-deletes the old delegation and all its descendants, then creates a new delegation.
   * No login required - uses HMAC token authentication.
   * @param documentRequestId
   * @param hmacToken
   * @param data
   * @returns RedelegateDocumentRequest
   * @throws ApiError
   */
  public static apiDocumentsRequestsRedelegateCreate(
    documentRequestId: string,
    hmacToken: string,
    data: RedelegateDocumentRequest,
  ): CancelablePromise<RedelegateDocumentRequest> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/redelegate',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
      },
      body: data,
    });
  }
  /**
   * @param documentRequestId
   * @param hmacToken
   * @param mdPk
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsRequestsSignedUrlRead(
    documentRequestId: string,
    hmacToken: string,
    mdPk: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/signed-url/{md_pk}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
        'md_pk': mdPk,
      },
    });
  }
  /**
   * @param documentRequestId
   * @param hmacToken
   * @param taskId
   * @param data
   * @returns TaskModel
   * @throws ApiError
   */
  public static apiDocumentsRequestsTaskStatusUpdate(
    documentRequestId: string,
    hmacToken: string,
    taskId: string,
    data: TaskModel,
  ): CancelablePromise<TaskModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/task-status/{task_id}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
        'task_id': taskId,
      },
      body: data,
    });
  }
  /**
   * @param documentRequestId
   * @param hmacToken
   * @param taskId
   * @param data
   * @returns TaskModel
   * @throws ApiError
   */
  public static apiDocumentsRequestsTaskStatusPartialUpdate(
    documentRequestId: string,
    hmacToken: string,
    taskId: string,
    data: TaskModel,
  ): CancelablePromise<TaskModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/requests/{document_request_id}/{hmac_token}/task-status/{task_id}',
      path: {
        'document_request_id': documentRequestId,
        'hmac_token': hmacToken,
        'task_id': taskId,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this file.
   * @param data
   * @returns FileUpdateRequestedFiles
   * @throws ApiError
   */
  public static apiDocumentsUpdateRequestedFileUpdate(
    id: number,
    data: FileUpdateRequestedFiles,
  ): CancelablePromise<FileUpdateRequestedFiles> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/documents/update-requested-file/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this file.
   * @param data
   * @returns FileUpdateRequestedFiles
   * @throws ApiError
   */
  public static apiDocumentsUpdateRequestedFilePartialUpdate(
    id: number,
    data: FileUpdateRequestedFiles,
  ): CancelablePromise<FileUpdateRequestedFiles> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/update-requested-file/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param docsId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsAddToFolderCreate(
    docsId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/{docs_id}/add-to-folder',
      path: {
        'docs_id': docsId,
      },
    });
  }
  /**
   * @param docsId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFilesCreate(
    docsId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/{docs_id}/files',
      path: {
        'docs_id': docsId,
      },
    });
  }
  /**
   * @param docsId
   * @param fileId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFilesRead(
    docsId: string,
    fileId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/{docs_id}/files/{file_id}',
      path: {
        'docs_id': docsId,
        'file_id': fileId,
      },
    });
  }
  /**
   * @param docsId
   * @param fileId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFilesUpdate(
    docsId: string,
    fileId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/documents/{docs_id}/files/{file_id}',
      path: {
        'docs_id': docsId,
        'file_id': fileId,
      },
    });
  }
  /**
   * @param docsId
   * @param fileId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFilesPartialUpdate(
    docsId: string,
    fileId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/{docs_id}/files/{file_id}',
      path: {
        'docs_id': docsId,
        'file_id': fileId,
      },
    });
  }
  /**
   * @param docsId
   * @param fileId
   * @returns void
   * @throws ApiError
   */
  public static apiDocumentsFilesDelete(
    docsId: string,
    fileId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/documents/{docs_id}/files/{file_id}',
      path: {
        'docs_id': docsId,
        'file_id': fileId,
      },
    });
  }
  /**
   * @param docsId
   * @param fileId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFilesVersionsRead(
    docsId: string,
    fileId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/{docs_id}/files/{file_id}/versions',
      path: {
        'docs_id': docsId,
        'file_id': fileId,
      },
    });
  }
  /**
   * @param docsId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsFolderCreate(
    docsId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/documents/{docs_id}/folder',
      path: {
        'docs_id': docsId,
      },
    });
  }
  /**
   * @param docsId
   * @param folderId
   * @returns FolderView
   * @throws ApiError
   */
  public static apiDocumentsFolderRead(
    docsId: string,
    folderId: string,
  ): CancelablePromise<FolderView> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/{docs_id}/folder/{folder_id}',
      path: {
        'docs_id': docsId,
        'folder_id': folderId,
      },
    });
  }
  /**
   * @param docsId
   * @param folderId
   * @param data
   * @returns FolderModel
   * @throws ApiError
   */
  public static apiDocumentsFolderUpdate(
    docsId: string,
    folderId: string,
    data: FolderModel,
  ): CancelablePromise<FolderModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/documents/{docs_id}/folder/{folder_id}',
      path: {
        'docs_id': docsId,
        'folder_id': folderId,
      },
      body: data,
    });
  }
  /**
   * @param docsId
   * @param folderId
   * @param data
   * @returns FolderView
   * @throws ApiError
   */
  public static apiDocumentsFolderPartialUpdate(
    docsId: string,
    folderId: string,
    data: FolderView,
  ): CancelablePromise<FolderView> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/documents/{docs_id}/folder/{folder_id}',
      path: {
        'docs_id': docsId,
        'folder_id': folderId,
      },
      body: data,
    });
  }
  /**
   * @param docsId
   * @param folderId
   * @returns void
   * @throws ApiError
   */
  public static apiDocumentsFolderDelete(
    docsId: string,
    folderId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/documents/{docs_id}/folder/{folder_id}',
      path: {
        'docs_id': docsId,
        'folder_id': folderId,
      },
    });
  }
  /**
   * @param mdId
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsReferencesRead1(
    mdId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/{md_id}/references',
      path: {
        'md_id': mdId,
      },
    });
  }
  /**
   * @param mdPk
   * @returns any
   * @throws ApiError
   */
  public static apiDocumentsRead(
    mdPk: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/documents/{md_pk}',
      path: {
        'md_pk': mdPk,
      },
    });
  }
}
